import React from 'react';
import styled from 'styled-components';

import { IconButton } from '@mui/material';
import { useTheme } from '../../../../../styles';
import { DeleteOutlineOutlined } from '@mui/icons-material';
import { Expression } from '@common/Expression';
import { Command } from '@store/index';
import { NodeField } from '@components/Flow/Nodes';
import { useNodeData } from '@common/hooks/useNodeData';

const Container = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 42px;
`;

const Action = styled.div`
  display: flex;
  align-items: center;

  svg {
    font-size: 2ch;
  }
`;

interface Props {
  id: string;
  value: string;
  field: NodeField;
  command: Command;
  updateField: (id: string, value: string) => void;
  deleteField: (id: string) => void;
}

export const MediaParameterExpression: React.FC<Props> = ({ id, value, field, command, updateField, deleteField }) => {
  const theme = useTheme();

  const { label, description } = field;
  const { getOptions, dataEdges } = useNodeData(command?.node?.id);

  const dataOptions = getOptions(command?.node?.id);
  const totalAvailableWidth = (window.innerWidth - 60) * (2.5 / (7.5 + 2.5)) - 80;

  return (
    <Container>
      <Expression
        key={`${id}-${command.node.id}-${field.id}`}
        keyProp={`${id}-${command.node.id}-${field.id}`}
        value={value}
        dataEdges={dataEdges}
        wrapping={false}
        title={label}
        description={description}
        setValue={(newValue) => updateField(id, newValue)}
        options={dataOptions}
        placeholder='value'
        minRows={1}
        maxRows={1}
        maxWidth={`${totalAvailableWidth}px`}
      />
      <Action>
        <IconButton
          sx={{ border: `1px solid ${theme.line.light}`, height: '42px', width: '42px' }}
          onClick={() => deleteField(id)}
        >
          <DeleteOutlineOutlined sx={{ fontSize: '1.4ch !important', color: theme.text.subtext }} />
        </IconButton>
      </Action>
    </Container>
  );
};
